import React, { Component } from "react";
import FormStorageCom from "../Component/FormStorage_Com";
import SideBar from "../Component/Sidebar_Com";
import { close, generateToast } from "../Logic/toast_handler";
import ToastComp from "../Component/Toast_Com";
import { storage } from "../Logic/handler";
import { Button, Modal } from "react-bootstrap";

class FormStorage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showToast: [],
      toastData: [],
      showModal: false,
      modalData :{}
    };
  }

  setCurrState = (data, afterFunc, paramFunc) => {
    this.setState(
      {
        ...data,
      },
      () => {
        if (afterFunc) {
          afterFunc(...paramFunc);
        }
      }
    );
  };

  showModal = (isShow) => {
    this.setState({
      showModal: true,
    });
    console.log(this.state.modalData)
  };

  render() {
    return (
      <div className="home">
        <SideBar />
        <div className="main">
          <FormStorageCom 
            generateToast={generateToast}
            setParent={this.setCurrState}
            toast={[this.state.toastData,this.state.showToast]}
            showModal={this.showModal}
            {...this.props}
          />
        </div>
        <div className="toast_container">
          {this.state.showToast.map((item, index) => {
            return (
              item && (
                <ToastComp
                  data={this.state.toastData[index]}
                  close={() =>
                    close(
                      this.state.toastData[index].idx,
                      this.state.toastData[index].pos,
                      [this.state.toastData,this.state.showToast],
                      this.setCurrState
                    )
                  }
                  isShow={this.state.showToast[index]}
                />
              )
            );
          })}
          <Modal
            show={this.state.showModal}
            onHide={()=>this.props.history.push("/Storage")}
            backdrop="static"
          >
            <Modal.Header closeButton>
              <Modal.Title>Sukses!!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>
                Data storage telah berhasil disimpan
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={()=>this.props.history.push("/Storage")}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

export default FormStorage;
